import cn from 'classnames'
import type {CSSProperties} from 'react'
import {memo} from 'react'
import styles from './icon.module.css'

export const iconNames = [
  'arrow-right',
  'avatars',
  'calendar',
  'calendar-filled',
  'check',
  'check-mark',
  'facebook-icon',
  'fill-check',
  'linkedin-icon',
  'logo',
  'plus',
  'map',
  'minus',
  'pagination-arrow',
  'small-logo',
  'tick',
  'twitter-icon',
  'right-arrow',
  'chevron',
  'chevron-v2',
  'G2',
  'Capterra',
  'check-mark-v2',
  'check-bold',
  'info',
  'info-hover',
  'search',
  'cross',
  'clock-filled',
  'moss-logo',
  'moss-logo-v2',
  'card',
  'wallet',
  'invoice',
  'insights',
  'accounting',
  'request',
  'requests-filled',
  'org-chart',
  'filled-check-v2',
  'play',
  'pause',
  'sound-active',
  'sound-muted',
  'zoom-in',
  'zoom-out',
  'play-circle',
  'replay',
  'outline-check-v2',
  'quotation-mark',
  'map-pin',
  'shopping-cart',
  'monitor',
  'map-pin-filled',
  'company',
  'dinner',
  'filled-cross',
  'plus-bold',
  'plus-thin',
  'plus-bold-rounded',
  'lock',
  'cross-bold',
  'moss-woodmark',
  'corner',
  'arrow',
  'group',
  'linkedin-logo',
  'datev-marketplace',
  'heart-pulse',
  'download',
  'sparkle',
  'pencil',
  'list',
  'anthropic-logo',
  'chatgpt-logo',
  'apple-logo',
  'windows-logo',
  'copy',
  'arrow-down',
  'arrow-diagonal-filled',
  'fullscreen',
  'database',
  'laptop',
  'shield',
  'people',
  'chat',
  'chart',
  'key',
  'document',
  'clock',
  'bolt',
] as const

export type IconType = (typeof iconNames)[number]

export const Icon = memo(function (
  props: {
    className?: string
    label?: string
    noMask?: boolean
    testId?: string
  } & (
    | {
        name: IconType
        path?: never
      }
    | {
        name?: never
        path: string
      }
  ),
) {
  return (
    <span
      {...((props.label || props.name) && {'aria-label': props.label || props.name})}
      className={cn(
        styles.icon,
        'pointer-events-none inline-block',

        {
          'bg-current': !props.noMask,
          'no-mask': props.noMask,
        },

        props.className,
      )}
      {...(props.testId && {'data-testid': props.testId})}
      role="img"
      style={
        {
          '--image': `url("${props.path ?? `/icons/${props.name}.svg`}")`,
          '--webkit-transform': 'translate3d(0,0,0)',
        } as CSSProperties
      }
    />
  )
})
